<app-platform-degraded-banner></app-platform-degraded-banner>
<router-outlet></router-outlet>
<app-toast-container #toastContainer></app-toast-container>
